import { Transition } from '@uirouter/core';
import { Action } from '../../common/actions/core/action';
import { FamilyPlanTypes } from '../../common/services/package/package.model';

export class OpenUserRegistrationAction implements Action {
  constructor(
   public type: FamilyPlanTypes
  ) {}
}



// WEBPACK FOOTER //
// src/app/family-plan/family-plan-user-registration-dialog/family-plan-user-registration-dialog.action.ts